import React, { Component } from "react";
import styles from "./Popup.module.scss";
// import schedulerStyes from "../../components/Scheduler/SchedulerModal.module.scss"
import Wrapper from "../../hoc/Wrapper/Wrapper";
import { withRouter } from "react-router-dom";
import copy from '../../assets/copy/copy.json';
import Button from "../UI/Button/Button";
import Icon from "../UI/Icon/Icon";

var classNames = require("classnames");

class AvailabilityTypeModal extends Component {
  constructor(props) {
    const agencyAvailabilityTypes = copy.myAvailabilityScreen.agencyAvailabilityTypes;
    const types = agencyAvailabilityTypes[props.userAgency]
    const selectedTypes = Object.fromEntries(types.map(type => [type, false]))
    props.selectedAvailabilityTypes?.forEach(type => selectedTypes[type] = true)
    super(props);
    this.state = {
      showPopup: false,
      userAgency: props.defaultAgency,
      selectedTypes,
    };
  }

  componentWillUnmount() {
    this.setState({ showPopup: false });
  }

  handleOnChange = () => {
    let selectedOptions = Object.keys(this.state.selectedTypes).filter(e => this.state.selectedTypes[e])
    this.props.onChange(selectedOptions)
  }

  renderMyAvailabilityButtons = (emergencyLevels) => {

    const levelToColour = copy.myAvailabilityScreen.availabilityStyles
    const deleteIcon = <Icon
      icon="icon_delete"
    />

    return (
      emergencyLevels.map((level) => {
        return <Button
          label={level}
          key={level}
          buttonClick={
            this.props.singleSelect ?
              () => this.props.submitForm(level) :
              () => this.setState({ selectedTypes: { ...this.state.selectedTypes, [level]: !this.state.selectedTypes[level] } }, this.handleOnChange)}
          content={
            <div>
              {this.props.singleSelect ?
                <input className="radioLarge" type="radio" defaultChecked={level === this.props.selectedAvailabilityType} /> :
                <input className="radioLarge" type="checkbox" checked={this.state.selectedTypes[level]} />
              }
              <div>{level}</div>
            </div>
          } variant="btn_primary"
          styles={levelToColour[level] + " selected"}
        />
      }).concat(
        (this.props.singleSelect ?
          <Button
            label="Delete"
            key={"Delete"}
            buttonClick={() => this.props.submitForm("Delete")}
            content={
              <div>
                <input className="radioLarge" type="radio" defaultChecked={"Delete" === this.props.selectedAvailabilityType} />
                {deleteIcon}
                <div>Delete</div>
              </div>
            }
            styles={levelToColour["Delete"] + " selected"}
            variant="btn_primary"
          /> :
          <Button
            label="Clear selected"
            key={"Clear selected"}
            buttonClick={() => {
              const selectedTypes = this.state.selectedTypes
              Object.keys(selectedTypes).forEach(type => selectedTypes[type] = false)
              this.setState({ selectedTypes }, this.handleOnChange)
            }
            }
            content={
              <div>
                <div className="clearSelectedPadding">Clear selected</div>
              </div>
            }
            styles={levelToColour["Delete"] + " selected"}
            variant="btn_primary"
          />)
      )
    )
  }

  render() {
    if (this.props.isVisible) {
      document.body.classList.add("popup-mode");
    } else {
      document.body.classList.remove("popup-mode");
    }

    let CloseAlertControls = classNames(
      "tileBg2 " + styles.closeAlertControls,
      this.props.className,
      {
        [styles.visible]: this.props.isVisible,
      }
    );

    let DarkMask = classNames(styles.darkMask, this.props.className, {
      [styles.visible]: this.props.isVisible,
    });


    const agencyAvailabilityTypes = copy.myAvailabilityScreen.agencyAvailabilityTypes;
    const emergencyLevels = agencyAvailabilityTypes[this.props.userAgency]

    return (
      <Wrapper>
        <div>
          <div
            className={CloseAlertControls}
            style={{
              "position": "absolute",
              "left": `${this.props.position.left}px`,
              "top": `${this.props.position.bottom + 5}px`,
              "margin": "0",
              "transform": "none",
            }}
          >
            <div className={styles.content + " " + styles.availabilityModal}>
              <div
                className={styles.controls}
                style={{
                  "padding": "0"
                }}
              >
                {this.renderMyAvailabilityButtons(emergencyLevels)}
              </div>
            </div>
          </div>
          <div className={DarkMask} onClick={this.props.closeDropdown} />
        </div>
      </Wrapper >
    );
  }
}

export default withRouter(AvailabilityTypeModal);
